import { Outlet, useLocation } from 'react-router-dom';
import { ClientHeader } from './ClientHeader';
import { CartDrawer } from './CartDrawer';

/**
 * Coquille du mode client : en-tête + contenu, rien d'autre.
 *
 * Pas de sidebar, pas de pied de page, pas de bandeau d'aperçu — l'écran est
 * montré au client de l'électricien et ne doit exposer aucune navigation
 * métier (devis, portefeuille, statistiques, paramètres).
 *
 * Le `CartDrawer` est le MÊME composant qu'en mode électricien et lit le même
 * `CartProvider` (monté une seule fois au-dessus des deux coquilles) : ce que
 * le client compose ici est le panier que l'électricien retrouve en sortant.
 */
export function ClientLayout() {
  const location = useLocation();

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: 'var(--pro-bg)' }}
    >
      <ClientHeader />
      <main className="flex-1 overflow-y-auto">
        <div key={location.pathname} className="px-4 sm:px-6 pb-8 pro-fade-in">
          <Outlet />
        </div>
      </main>
      <CartDrawer />
    </div>
  );
}
